import React from 'react';
import { getSportClassByPresentationId, MatchTrackerType } from 'eTip--common';

export interface IMatchTrackerSelectionItem {
    id: number;
    matchId: string | null;
    type: MatchTrackerType;
    title: string;
    graphicsPresentationId: number;
}

export interface IMatchTrackerSelectionProps {
    graphicsPresentationId: number;
    eventName: string;
    availableEvents: IMatchTrackerSelectionItem[];
    onClose: () => void;
    onOpen: (event: IMatchTrackerSelectionItem) => void;
}

export const MatchTrackerSelection = (props: IMatchTrackerSelectionProps) => {
    const [isEventListOpen, setIsEventListOpen] = React.useState(false);

    return <div className="live-stream-selection">
        <div className="selected-option d-flex align-items-center">
            <span className={`sport-icon icon-in-title cursor-pointer ${getSportClassByPresentationId(props.graphicsPresentationId)}`} onClick={() => { setIsEventListOpen(!isEventListOpen) }}></span>
            <span className="text-truncate match-title cursor-pointer" onClick={() => { setIsEventListOpen(!isEventListOpen) }}>{props.eventName}</span>
            <span className="ml-auto icons">
                <a className="mr-1" onClick={() => { setIsEventListOpen(!isEventListOpen) }}>
                    <i className={"fa " + (isEventListOpen ? "fa-caret-right" : "fa-caret-down")}></i>
                </a>
                <a onClick={() => { props.onClose(); }} > {/** tooltip="{{'liveStream.tooltipClose'|translate}}" */}
                    <i className="fa fa-times"></i>
                </a>
            </span>
        </div>
        {
            isEventListOpen &&
            <div className="mt-game-list">
                {Array.from(props.availableEvents.values()).map(item => (  /* TODOH TODOLS expensive? */
                    <div key={item.id} className="d-flex mt-game-item" onClick={() => { props.onOpen(item); setIsEventListOpen(false); }}>
                        <span className={"sport-icon icon-in-title " + getSportClassByPresentationId(item.graphicsPresentationId)}></span>
                        <span className="text-truncate mt-game-title">{item.title}</span>
                    </div>
                ))}
            </div>
        }
    </div>
}